import React, { ReactElement } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import RemoveIcon from '@material-ui/icons/HighlightOff';
import { CartItem as CartItemInterface } from '../types';
import { useStyles } from './styles';
import ProductPriceTable from './ProductPriceTable';
import ProductQuantityField from './ProductQuantityField';

interface Props {
  loading: boolean;
  product: CartItemInterface;
  updateCartPrice(quantity: number): void;
  showCartError(error: string): void;
  isCompact: boolean;
}

const CartItem = ({
  loading,
  product,
  updateCartPrice,
  showCartError,
  isCompact,
}: Props): ReactElement => {
  const classes = useStyles({ isCompact });
  return (
    <div aria-label="cart-item" className={classes.container}>
      <div className={classes.productRow}>
        <div aria-label="product-label-container" className={classes.productLabelContainer}>
          <div aria-label="product-label" className={classes.productName}>
            {product.name}
          </div>
          {isCompact && (
            <div className={classes.compactQuantityFieldContainer}>
              <ProductQuantityField
                product={product}
                updateCartPrice={updateCartPrice}
                showCartError={showCartError}
              />
            </div>
          )}
        </div>
        <TableContainer className={classes.tableContainer}>
          <ProductPriceTable
            isCompact={isCompact}
            product={product}
            loading={loading}
            updateCartPrice={updateCartPrice}
            showCartError={showCartError}
          />
        </TableContainer>
      </div>

      <div className={classes.buttonContainer}>
        <RemoveIcon
          classes={{ root: classes.removeButton }}
          aria-label="delete"
          onClick={() => {
            updateCartPrice(0);
          }}
        />
      </div>
    </div>
  );
};

export default CartItem;
